module.exports = __webpack_public_path__ + "img/app_brand_bioTrackTHC.acbfba1f.svg";